import { useMemo } from "react";
import { pctInLevel, skillIcon, SKILL_LABEL } from "@/lib/gameData";

export function SkillRing({ skill, size = 68, testid }) {
  const pct = pctInLevel(skill);
  const strokeWidth = 6;
  const r = (size - strokeWidth) / 2;
  const c = 2 * Math.PI * r;
  const offset = c * (1 - pct / 100);
  const iconUrl = skillIcon(skill?.__name);

  return (
    <div
      className="relative"
      style={{ width: size, height: size }}
      data-testid={testid}
    >
      <svg width={size} height={size} className="-rotate-90">
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="#292524"
          strokeWidth={strokeWidth}
          fill="transparent"
        />
        <circle
          cx={size / 2}
          cy={size / 2}
          r={r}
          stroke="#f59e0b"
          strokeWidth={strokeWidth}
          strokeLinecap="round"
          fill="transparent"
          strokeDasharray={c}
          strokeDashoffset={offset}
          className="ring-progress"
          style={{ filter: "drop-shadow(0 0 4px rgba(245,158,11,0.4))" }}
        />
      </svg>
      <div className="absolute inset-0 flex items-center justify-center">
        {iconUrl ? (
          <img
            src={iconUrl}
            alt={SKILL_LABEL[skill?.__name] || ""}
            className="w-8 h-8 object-cover rounded-full"
            style={{ boxShadow: "inset 0 0 6px rgba(0,0,0,0.6)" }}
          />
        ) : (
          <span className="font-numeric text-amber-500 text-xs uppercase">
            {(skill?.__name || "").slice(0, 3)}
          </span>
        )}
      </div>
      <div
        className="absolute -bottom-1 -right-1 rounded-full bg-stone-950 border border-amber-700 px-1.5 py-0.5 font-numeric text-[10px] text-amber-300"
        style={{ minWidth: 22, textAlign: "center" }}
      >
        {skill?.level ?? 1}
      </div>
    </div>
  );
}

export function XpBar({ skill }) {
  const pct = pctInLevel(skill);
  return (
    <div className="xp-bar-outer" title={`${skill?.xp_into ?? 0} / ${skill?.xp_needed ?? 0} XP`}>
      <div className="xp-bar-fill" style={{ width: `${pct}%` }} />
    </div>
  );
}
